import CommonService from '../../../../services/commonService';
import React from 'react';

const HeroSection = props => {

	return (
		<div
			style={{
				// height: props.height || '50vh',
				// marginBottom: '30px',
				// marginTop: props.marginTop ? props.marginTop : '',
				marginTop: props.operator && props.operator.operator_name === 'aeroquinta' ? '90px' : (props.marginTop ? props.marginTop : ''),

			}}
		>
			<div className="hero-section-container">
				<div className="hero-image-container">
					<img src={props.heroImage} alt="hero-view" />
				</div>

				{props.title && (
					<div className="hero-overlap">
						<div className="punch-line">
							<div className="punch-line-container">
								<span className="font26 new-bold-font general-text white-text">{props.title}</span>
							</div>

							{props.description && (
								<div>
									<span className="font10 general-text white-text less-bold-text">
										{props.description}
									</span>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default HeroSection;



// WEBPACK FOOTER //
// ./src/features/themes/common/HeroSection/HeroSection.js